export default "/images/301bf736163d982992ea99ff7ea6e951.avif";